import theme from "@/styles/theme";
import styled from "styled-components";

export const CriterioRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    font-family: sans-serif;
    font-size: ${theme.fontSize.md};
    color: ${theme.colors.palete.brownDark};
    margin-bottom: 1vh;
    text-align: center;
    @media ${theme.devices.tablet} {
      margin-top: 0vh;
    }
    strong {
      color: black;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .description {
    text-align: justify;
    background-color: ${theme.colors.palete.brownLight};
    padding: 10px;
    margin-top: 0vh;
    margin-bottom: 2vh;
    border-radius: 5px;
    color: white;
  }
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  width: 100%;
  height: 75vh;
  row-gap: 1vh;
  margin-top: 3vh;
  margin-bottom: 4vh;
  overflow-y: scroll;
  @media ${theme.devices.tablet} {
    height: 75vh;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: -4vh;
  justify-content: center;
  @media ${theme.devices.tablet} {
    margin-top: -3vh;
  }
`;
